import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle2, XCircle } from 'lucide-react';

// Stripe success/cancel landing (payments.py success_url/cancel_url point here).
export default function PaymentResult({ ok }) {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900 px-4"
         data-testid={ok ? 'payment-success' : 'payment-cancel'}>
      <div className="bg-white dark:bg-slate-800 rounded-xl p-8 text-center max-w-md space-y-3 border">
        {ok
          ? <CheckCircle2 className="h-14 w-14 mx-auto text-green-500" />
          : <XCircle className="h-14 w-14 mx-auto text-red-500" />}
        <h1 className="text-xl font-bold">{ok ? 'Payment received' : 'Payment canceled'}</h1>
        <p className="text-slate-500 text-sm">
          {ok
            ? 'Thank you — your registration payment is being confirmed. You will get a receipt by email.'
            : 'No charge was made. You can return and try again.'}
        </p>
        {sessionId && ok && <p className="text-xs text-slate-400 break-all">Ref: {sessionId}</p>}
        <Link to="/" className="inline-block mt-2 px-4 py-2 rounded-lg bg-amber-600 text-white text-sm">Back to home</Link>
      </div>
    </div>
  );
}
